export const contactInfo = {
  email: "ryanhuse@gmail.com",
  location: "Houston, TX",
  social: {
    linkedin: {
      url: "https://www.linkedin.com/in/ryan-huse/",
      username: "ryan-huse",
    },
    // Add more social platforms as needed
    // twitter: {
    //   url: "https://twitter.com/yourusername",
    //   username: "@yourusername"
    // },
  },
  // Optional additional fields
  availability: {
    status: "currently employed, open to interesting projects",
  },
  preferredContact: "email ", // or "linkedin"
  timezone: "CST", // Your timezone
  languages: ["English"], // Languages you speak
  responseTime: "24-48 hours", // Expected response time
};
